import { render, staticRenderFns } from "./ProcessCellList.vue?vue&type=template&id=a837c160&scoped=true&"
import script from "./ProcessCellList.vue?vue&type=script&lang=ts&"
export * from "./ProcessCellList.vue?vue&type=script&lang=ts&"
import style0 from "./ProcessCellList.vue?vue&type=style&index=0&id=a837c160&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a837c160",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
